import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Developer accounts allowed to view the demo/showcase pages.
// Gates on user.accountId from the JWT payload — accountIds are opaque identifiers,
// so unlike emails they disclose nothing personal in the public JS bundle.
const DEV_ACCOUNT_IDS = [
    "68e3642397810ed5dc41fcec", // dev database developer login (yadawn-dev)
    "6875db5c5dbe408d70aa37d9", // production developer/test account (yadawn22)
];

// Component to protect developer-only routes (demo/showcase pages).
// Anyone not logged in as a developer account is redirected home.
function DevProtectedRoute({ children }) {
    const { user, loading, isAuthenticated } = useAuth();

    if (loading) {
        return <div>Loading Authentication...</div>;
    }

    // Anyone who isn't a developer account (including logged-out visitors) goes home,
    // so the route is indistinguishable from a URL that doesn't exist.
    if (!isAuthenticated || !DEV_ACCOUNT_IDS.includes(user?.accountId)) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default DevProtectedRoute;
